import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ProductsSection from "./components/ProductsSection";
import AboutSection from "./components/AboutSection";
import ValueAddSection from "./components/ValueAddSection";
import DistributorSection from "./components/DistributorSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { MessageCircle } from "lucide-react";

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen overflow-x-hidden" data-testid="app-root">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ProductsSection />
      <AboutSection />
      <ValueAddSection />
      <DistributorSection />
      <ContactSection />
      <Footer />
      <Toaster position="top-right" theme="dark" richColors />

      {/* WhatsApp Floating Action Button */}
      <a
        href="https://wa.me/919502343899?text=Hi%2C%20I%27m%20interested%20in%20MakhanaG%20premium%20makhana"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-fab"
        className="whatsapp-fab fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-[0_4px_20px_rgba(34,197,94,0.4)] flex items-center justify-center group"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={26} />
        <span className="absolute right-full mr-3 bg-[#121212] text-white text-xs font-medium px-3 py-2 rounded-lg border border-white/10 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-lg">
          Chat on WhatsApp
        </span>
      </a>
    </div>
  );
}

export default App;
